import {graphql, useStaticQuery} from "gatsby";
import {translate} from "../helpers/lang";


export const useNav =(lang)=>{
  const data = useStaticQuery(graphql`
    {
      allHome {
        edges {
          node {
            data {
              nav {
              menu {
              contact {
                en
                fr
              }
              expertises {
                en
                fr
              }
              home {
                en
                fr
              }
              projects {
                en
                fr
              }
            }
                slugs {
                  contact {
                    en
                    fr
                  }
                  expertises {
                    en
                    fr
                  }
                  home {
                    en
                    fr
                  }
                  projects {
                    en
                    fr
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
      const menuList = data?.allHome?.edges[0]?.node?.data?.nav?.menu
  return  {
    menu :menuList ,
    slugTranslate :  translate(lang, data?.allHome?.edges[0]?.node?.data?.nav?.slugs),
    menuTranslate: translate(lang ,menuList)
  }   ;
}